<template>
  <div class="w-full h-full">
    <div class="my-10px flex items-center h-36px">
      <TableButtonGroup
        :list="btnList"
        v-model="btn"
        :disabledList="['检修计划']"
        @btn-click="btnTabClick"
      ></TableButtonGroup>
      <el-select
        v-model="metalBimSelectValue"
        class="flex-1 ml-10px"
        @change="metalBimSelect"
        popper-class="visualization-select-popper"
        v-show="btn !== '统计信息'"
      >
        <el-option
          v-for="item in metalBimOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <el-input
      v-if="btn === '台账信息'"
      placeholder="请输入关键词"
      v-model="metalBimKeyword"
      size="small"
      clearable
      @keypress.enter.native="getTableData()"
      class="icon-search__input mb-10px"
    >
      <i
        slot="append"
        class="el-icon-search cursor-pointer icon-search__input"
        @click="getTableData()"
      ></i>
    </el-input>
    <div v-if="btn === '台账信息'" class="h-full w-full">
      <el-table
        :data="tableData"
        highlight-current-row
        class="!h-[calc(100%-132px)] !w-full"
        ref="tableRef"
        v-loading="tableLoading"
      >
        <el-table-column label="" width="15">
          <template>
            <div class="selected-row"></div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in tableColumns"
          :key="index"
          :label="item.label"
          :width="item.width"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div
              v-if="item.type === 'ThreeDimensional'"
              @click="moveThreeD(scope.row)"
              class="cursor-pointer text-hex-00bcc8 truncate w-full"
            >
              {{ scope.row[item.prop] }}
            </div>
            <div v-else class="truncate w-full">{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{ row }">
            <div @click="lookDetail(row)" class="cursor-pointer text-hex-00bcc8">查看</div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        small
        background
        @size-change="getTableData()"
        @current-change="getTableData()"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :pager-count="5"
        layout="total, prev, pager, next"
        :total="page.total"
        class="text-center"
      ></el-pagination>
    </div>
    <MetalBimDetail
      v-if="MetalBimDetailVis"
      @close="MetalBimDetailVis = false"
      :title="title"
      :bimDetail="bimDetail"
      :type="type"
    />
    <Statistics
      class="h-[calc(100%-43px)]"
      v-if="btn === '统计信息'"
      @openAlertList="openAlertList"
      :player="player"
      :cloudRender="cloudRender"
      :customProps="customProps"
    ></Statistics>
  </div>
</template>

<script>
// api
import { MetalBIMApi } from '@wiz-api/huizhou2'

import { cloneDeep, find, get, maxBy, minBy, isEmpty } from 'lodash'

// metal default data
import { metalBimOptions, metalTableConfig } from './config'
import { isJSONObj } from '../../../assets/js/scene/scene'

// 实例化
const metalbimapi = new MetalBIMApi()

// components
const MetalBimDetail = () => {
  return import('./MetalBimDetail')
}
const Statistics = () => {
  return import('./Statistics')
}
const TableButtonGroup = () => {
  return import('@/components/cockpit/TableButtonGroup')
}

export default {
  components: { TableButtonGroup, MetalBimDetail, Statistics },
  name: 'MetalBimTest', // 跟组件注册名称不一样则不缓存
  data() {
    return {
      btn: '台账信息',
      btnList: ['统计信息', '台账信息', '检修计划'],
      metalBimSelectValue: 'pipelineFoundationLedger',
      metalBimOptions,
      metalBimKeyword: '',
      tableData: [],
      tableLoading: true,
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      MetalBimDetailVis: false,
      title: '',
      bimDetail: {},
      type: 'pipelineFoundationLedger',
      defaultInfo: {},
      currentHideModelItem: null,
    }
  },

  methods: {
    openAlertList(val) {
      this.$emit('transferEvent', {
        toCom: { code: 'MetAlalertList', origin: 'MetalBim', name: '预警列表' },
        type: 'mainComponent',
        props: {
          name: val,
        },
      })
    },
    btnTabClick(val) {
      this.btn = val
      this.cloudRender.NodeProxy.removeSelectedItem() // 取消选中
    },
    async metalBimSelect(val) {
      this.type = val
      // 取消当前table行高亮
      this.$refs.tableRef.setCurrentRow()
      // 切换之后发请求获取新的table数据
      await this.getTableData()
    },
    async getTableData() {
      this.tableLoading = true
      const [err, data] = await metalbimapi[this.searchApi](this.page.pageNo, this.page.pageSize, {
        keyWord: this.metalBimKeyword,
        metalType: this.metalType,
      })
      if (!err && data) {
        this.tableData = data.items
        this.page.total = data.totalCount
        this.tableLoading = false
      } else {
        this.tableData = []
      }
    },
    async serachTableData() {
      this.page = this.$options.data().page
      await this.getTableData()
    },
    lookDetail(row) {
      this.type = this.metalBimSelectValue
      this.title = find(metalBimOptions, { value: this.metalBimSelectValue }).label
      this.MetalBimDetailVis = true
      this.bimDetail = {
        ...this.bimDetail,
        ...row,
      }
    },
    // 获取场景aabb
    async getSceneAabb(nodes) {
      const aabbList = []
      for (let i = 0; i < nodes.length; i += 1) {
        const item = nodes[i]
        // eslint-disable-next-line no-await-in-loop
        const aabb = await this.cloudRender.NodeProxy.getAabb(item)
        if (aabb) {
          aabbList.push(aabb.data.aabb)
        }
      }
      const maxX = maxBy(aabbList, (item) => {
        return item[1][0]
      })
      const maxY = maxBy(aabbList, (item) => {
        return item[1][1]
      })
      const maxZ = maxBy(aabbList, (item) => {
        return item[1][2]
      })
      const minX = minBy(aabbList, (item) => {
        return item[0][0]
      })
      const minY = minBy(aabbList, (item) => {
        return item[0][1]
      })
      const minZ = minBy(aabbList, (item) => {
        return item[0][2]
      })
      return {
        max: [maxX[1][0], maxY[1][1], maxZ[1][2]],
        min: [minX[0][0], minY[0][1], minZ[0][2]],
      }
    },
    async moveThreeD(row) {
      // 判断是否存在二级列表弹框
      if (this.metalChildCode && this.metalChildName) {
        this.$emit('transferEvent', {
          toCom: { code: this.metalChildCode, origin: 'MetalBim', name: this.metalChildName },
          type: 'mainComponent',
          props: {
            ...row,
            type: 'pipelineSecondaryLedger',
          },
        })
      }
      const metalModels = row.metalModels
      if (metalModels && !isEmpty(metalModels)) {
        const allInfoArr = []
        await this.getAllInfo(0, metalModels, allInfoArr)
        if (isEmpty(allInfoArr)) {
          this.returnHome()
          return
        }
        const allInfoArrItems = allInfoArr.map((it) => {
          return it.getDataInfo().item
        })
        this.cloudRender.NodeProxy.player.Native.ModelTree.setSelectItems(allInfoArrItems)
        // 移动至节点
        const modelAabb = await this.getSceneAabb(allInfoArr)
        const mat = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
        await this.cloudRender.Camera.player.Native.Camera.addMoveToAabb(modelAabb, mat, 0, 1, 2)
      } else {
        this.returnHome()
      }
    },
    // 获取所有点位信息
    async getAllInfo(index, data, tempArr) {
      if (index < data.length) {
        const result = await this.cloudRender.NodeProxy.getInfo('Code', data[index].modelId)
        if (result.status) {
          tempArr.push(result.data)
          // 设置节点颜色
          // await this.cloudRender.Camera.player.Native.ModelTree.setItemColor(
          //   result.data.getDataInfo().item,
          //   0x00ff6699
          // )
        }
        await this.getAllInfo(index + 1, data, tempArr)
      }
    },
    // 返回主视角
    async returnHome() {
      await this.cloudRender.NodeProxy.removeSelectedItem()
      if (this.customProps.sceneOptions && isJSONObj(this.customProps.sceneOptions.jsonData)) {
        const jsonData = JSON.parse(this.customProps.sceneOptions.jsonData)
        const cameraParams = isJSONObj(jsonData.cameraParams)
          ? JSON.parse(jsonData.cameraParams)
          : { eye: [-1028, 580, 13821], target: [-1028, 579, 85], up: [0, 1, 0] }
        const { eye, target, up } = cameraParams
        await this.cloudRender.Camera.moveCamera('CameraParam', { eye, target, up })
      } else if (this.customProps.sceneOptions.isEnableGis) {
        await this.cloudRender.Camera.moveCamera('LLH', [
          this.customProps.sceneOptions.longitude,
          this.customProps.sceneOptions.latitude,
          50,
        ])
      } else {
        await this.cloudRender.Camera.moveCamera('CameraParam', {
          eye: [-1028, 580, 13821],
          target: [-1028, 579, 85],
          up: [0, 1, 0],
        })
      }
    },
    close() {
      this.$emit('transferEvent', {
        toCom: { code: this.metalChildCode, origin: 'MetalBim', name: this.metalChildName },
        type: 'close',
        props: {},
      })
    },
    // 获取三维模型基础点选颜色信息
    async getPickupColorInfo() {
      const res = await this.cloudRender.Setting.get(['pickup.color'])
      if (res.status) {
        const resInfo = res.data[0]
        const defautInfo = {
          type: 'string',
          value: '0,1,0,0.392157',
          name: 'pickup.color',
        }
        this.defaultInfo = cloneDeep(resInfo || defautInfo)
        await this.cloudRender.Setting.set({
          ...this.defaultInfo,
        })
      }
    },
  },
  async created() {
    await this.getPickupColorInfo() // 先获取点选颜色信息 防止表格数据一获取 就进行高亮 pickup.color的基础新没拿到
    await this.getTableData()
  },
  computed: {
    tableColumns() {
      return metalTableConfig[this.metalBimSelectValue].tableHead
    },
    searchApi() {
      return metalTableConfig[this.metalBimSelectValue].api
    },
    metalType() {
      return find(metalBimOptions, { value: this.metalBimSelectValue }).label
    },
    metalChildCode() {
      return get(metalTableConfig[this.metalBimSelectValue], 'child.code')
    },
    metalChildName() {
      return get(metalTableConfig[this.metalBimSelectValue], 'child.name')
    },
    // 获取隐藏模型的名称
    hideModelName() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
          ?.metalBIMmodelId || ''
      )
    },
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    player: {
      type: Object,
      default: () => {},
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    customProps: {
      type: Object,
      default: () => {},
    },
  },

  watch: {
    transferProps: {
      handler(data) {
        if (data) {
          this.type = 'pipelineSecondaryLedger'
          this.bimDetail = { ...data }
          this.title = '管道二级台账'
          if (!this.MetalBimDetailVis) this.MetalBimDetailVis = true
        }
      },
      deep: true,
      immediate: false,
    },
    async btn(val) {
      if (val === '台账信息') {
        // 台账信息 跟随主系统高亮颜色
        await this.cloudRender.Setting.set({
          ...this.defaultInfo,
        })
      } else {
        // 统计信息 三维视角返回主视角 设置红色高亮
        this.returnHome()
        await this.cloudRender.Setting.set({
          name: 'pickup.color',
          type: 'string',
          value: '1,0,0,1',
        })
      }
    },
  },
  async mounted() {
    if (this.hideModelName && this.customProps.loadModelStatus) {
      this.currentHideModelItem = await this.cloudRender.NodeProxy.player.Native.ModelTree.findItemByName(
        this.hideModelName,
        0,
        true,
        3
      )
      if (!isEmpty(this.currentHideModelItem)) {
        await this.cloudRender.NodeProxy.player.Native.ModelTree.setItemVisible(
          this.currentHideModelItem.item,
          false
        )
      }
    }
  },
  async beforeDestroy() {
    this.close()
    this.returnHome()
    await this.cloudRender.Setting.set({
      ...this.defaultInfo,
    })
    this.cloudRender.NodeProxy.removeSelectedItem() // 取消选中
    // 显示贴图模型
    if (!isEmpty(this.currentHideModelItem)) {
      await this.cloudRender.NodeProxy.player.Native.ModelTree.setItemVisible(
        this.currentHideModelItem.item,
        true
      )
      this.currentHideModelItem = null
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background-color: #1e4960 !important;
  opacity: 1 !important;
}

::v-deep .el-upload-list__item:hover {
  background-color: transparent !important;
}

::v-deep .el-upload-list__item.is-success .el-upload-list__item-name:hover {
  color: var(--cockpitPaginationLiActiveBg);
}

::v-deep .el-upload-list__item .el-icon-upload-success {
  color: var(--cockpitPaginationLiActiveBg);
}

::v-deep .el-upload-list__item-name {
  color: var(--cockpitInputBorderColor);
}
</style>
